import { motion, useReducedMotion } from "framer-motion";
import { LOW_POWER } from "@/lib/perf";

const EASE = [0.2, 0.9, 0.2, 1];

/** Fade + blur + small translateY reveal for async content. */
export function Reveal({ children, delay = 0, className, as = "div", y = 8, duration = 0.55, ...rest }) {
  const reduce = useReducedMotion() || false;
  const Comp = motion[as] || motion.div;
  const blur = !LOW_POWER && !reduce;
  return (
    <Comp
      className={className}
      // Phones: opacity + transform only (GPU-composited, 60fps). Desktop: add the iOS fade-in blur.
      initial={reduce ? { opacity: 0 } : blur ? { opacity: 0, filter: "blur(14px)", y } : { opacity: 0, y }}
      animate={reduce ? { opacity: 1 } : blur ? { opacity: 1, filter: "blur(0px)", y: 0 } : { opacity: 1, y: 0 }}
      transition={{ duration: reduce ? 0.2 : LOW_POWER ? Math.min(duration, 0.4) : duration, delay: LOW_POWER ? Math.min(delay, 0.12) : delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Comp>
  );
}

/** Page-level fade + translate (enter only, so shared transitions stay intact). */
export function Page({ children, className }) {
  const reduce = useReducedMotion();
  return (
    <motion.main
      id="main"
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: EASE }}
    >
      {children}
    </motion.main>
  );
}
